import { InjectionToken } from '@angular/core';
import { SectionsEnum } from '../enums/sections.enum';

export const JOBS_PLACEMENTS_TITLES_TOKEN = new InjectionToken<Record<SectionsEnum, string>>('Titles for jobs and placements');
